import apiClient from '../helpers/apiClient'
import { setConfig } from '../helpers/set_config.helper'

export async function saveEmail (email) {
  return await apiClient.post(`${process.env.REACT_APP_CONFIRMATION_API}user/register`, { email })
}

export async function register (user, client) {
  return await apiClient.put(`${process.env.REACT_APP_CONFIRMATION_API}user/register`, { user, client })
}

export async function login (user) {
  return await apiClient.post(`${process.env.REACT_APP_CONFIRMATION_API}user/login`, user)
}

/* Superuser */
export async function loginSuperUser (user) {
  return await apiClient.post(`${process.env.REACT_APP_CONFIRMATION_API}user/login-superuser`, user)
}

export async function authorizedCode (userId, code) {
  return await apiClient.post(`${process.env.REACT_APP_CONFIRMATION_API}user/authentication-code`, { userId, code })
}

export async function getSpecificClient (clientId, token) {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`
    }
  }
  return await apiClient.get(`${process.env.REACT_APP_CONFIRMATION_API}user/superuser/${clientId}`, config)
}

export async function getDoctors (clientId, token) {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`
    }
  }
  return await apiClient.get(`${process.env.REACT_APP_CONFIRMATION_API}doctor/${clientId}`, config)
}

/* Superuser */

export async function recoverPassword (email) {
  return await apiClient.post(`${process.env.REACT_APP_CONFIRMATION_API}user/recover-password`, { email })
}

export async function verifyToken (user, token) {
  return await apiClient.post(process.env.REACT_APP_CONFIRMATION_API + 'user/verify-token', { user, token })
}

export async function getUsersByClient (user, clientId, token) {
  const config = await setConfig(user, token)
  return await apiClient.get(`${process.env.REACT_APP_CONFIRMATION_API}user/${clientId}`, config)
}

export async function createNewUser (user, adminUser, token) {
  const config = await setConfig(adminUser, token)
  return await apiClient.post(process.env.REACT_APP_CONFIRMATION_API + 'user/create', {
    user,
    adminUserEmail: adminUser.email
  }, config)
}

export async function updateUserRole (user, admin, token) {
  const config = await setConfig(admin, token)
  return await apiClient.put(process.env.REACT_APP_CONFIRMATION_API + 'user/update-role', { user }, config)
}

export async function deleteUser (user, admin, token) {
  const config = await setConfig(admin, token)
  return await apiClient.post(process.env.REACT_APP_CONFIRMATION_API + 'user/delete', { userId: user._id }, config)
}

export async function updateUserAndClient (user, client, token) {
  const config = await setConfig(user, token)
  return await apiClient.post(process.env.REACT_APP_CONFIRMATION_API + 'user/update', { user, client }, config)
}

export async function updateUser (user, admin, token) {
  const config = await setConfig(admin, token)
  return await apiClient.put(process.env.REACT_APP_CONFIRMATION_API + 'user/update', user, config)
}

export async function updatePassword (user, passwordData, token) {
  const config = await setConfig(user, token)
  return await apiClient.put(process.env.REACT_APP_CONFIRMATION_API + 'user/password', passwordData, config)
}

export async function hasPassword (userId) {
  return await apiClient.get(`${process.env.REACT_APP_CONFIRMATION_API}user/has-password/${userId}`)
}

export async function saveNewPassword (user) {
  return await apiClient.put(process.env.REACT_APP_CONFIRMATION_API + 'user/new-password', user)
}
